<template>
  <about-component/>
  <footer class="footer">
    <div class="page">
      <div class="row">
        <div class="col">
          <p>
            © {{ today.getFullYear() }} <strong>woypass.com.ar</strong> |
            <a href="/privacy">Política de privacidad</a> |
            <a href="https://forms.gle/y5B11uMuFZCx5xkh9" target="_blank">Arrepentimiento de compra</a>
          </p>
          <p class="footer-contacts">
            <a href="mailto:info@woypass.com.ar" class="contact-link">
              <i class="fa fa-envelope" aria-hidden="true" /> info@woypass.com.ar
            </a>
            <span class="separator">|</span>
            <a href="https://www.instagram.com/woypass" target="_blank" rel="noopener noreferrer" class="contact-link">
              <i class="fab fa-instagram" aria-hidden="true" /> @woypass
            </a>
            <span class="separator">|</span>
            <a href="https://wa.me/5491121826746" target="_blank" rel="noopener noreferrer" class="contact-link">
              <i class="fab fa-whatsapp" aria-hidden="true" /> +54 9 11 2182-6746
            </a>
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>
<script setup lang="ts">
const today = new Date();
</script>
<style scoped>
.footer-contacts {
  margin-top: 0.75rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 0.5rem 1rem;
}

.contact-link {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  text-decoration: none;
  transition: opacity 0.2s ease;
}

.contact-link:hover {
  opacity: 0.8;
  text-decoration: underline;
}

.separator {
  opacity: 0.6;
}

@media (max-width: 600px) {
  .separator {
    display: none;
  }
  .footer-contacts {
    flex-direction: column;
    gap: 0.5rem;
  }
}
</style>
